import { BlendModes, Scene } from "phaser";

import { padNumber  } from '../utils';

// The HUD scene is the scene that shows the points and the remaining time.
export class TimerScene extends Scene {
    
    remaining_time = 0;

    remaining_time_text;
    points_text;

    element;


    constructor() {
        //super("TimerScene");
        super({ key: 'TimerScene', active: false });

        this.rt;
    }

    init(data) {
        //this.cameras.main.fadeIn(1000, 0, 0, 0);
        this.remaining_time = data.remaining_time;
        this.status = data.status;
        this.triggered = false
    }

    create() {


         //  Hide the Game Scene so it doesn't render (as we don't need it rendering twice)
         //this.scene.setVisible(false, 'MenuScene');

        //const layer = this.add.layer();
        
        this.rt = this.add.renderTexture(0, 0,  this.scale.width, this.scale.height);
        this.rt.setVisible(false); // Hide the Render Texture; it's used for sampling
        //this.rt.setCrop(this.scale.width /2, this.scale.height - this.scale.height / 5, 290*2, 120*2);
        // Capture Scene A's current content into the Render Texture
        //this.rt.draw(this.scene.get('MenuScene').children.list, 0, 0);
        this.captureSceneA();

        if (!this.textures.exists('testydraw')) {
            this.rt.saveTexture('testydraw');
        }

        


        // const captureX = (this.scale.width - 290) / 2;
        // const captureY = (this.scale.height - 120) / 2;
        //  // Now extract that section from the render texture and make it a sprite
        // //  const sectionTexture = this.textures.createCanvas('sectionTexture', 290, 120);
        // //sectionTexture.context.drawImage(this.rt.canvas, captureX, captureY, 290, 120, 0, 0, 290, 120);
        // //  sectionTexture.refresh();

        // // Create a sprite that will display the frosted glass effect
        
        
        
        // this.frostedGlass = this.add.sprite(0,0, 'testydraw');
        // this.frostedGlass.setOrigin(0);

        // const cropRect = new Phaser.Geom.Rectangle(this.scale.width/2-290, this.scale.height - this.scale.height / 5 -120, 290*2, 120*2);
        // this.frostedGlass.setCrop(cropRect);
        // //this.frostedGlass.setTint('0x9c9c9c', '0x070012','0x070012','0x7f00ff');
        // //.setCrop(0,0,200,200);
        
        // this.frostedGlass.postFX.addBlur(2, 1, 1,3, 0xffffff,4);

        // // this.camera = this.cameras.add(this.scale.width /2- 290, this.scale.height - this.scale.height / 5 -120,  290*2, 120*2).setOrigin(0.5);
        // // this.camera.zoom = 2;
        // // this.camera.setScroll(this.scale.width /2, this.scale.height - this.scale.height / 5);
        // //this.camera.setBackgroundColor('rgba(0, 0, 0, 0.15)');

        // // this.rect = this.add.rexRoundRectangle({
        // //     x: this.scale.width /2,
        // //     y: this.scale.height - this.scale.height / 5,
        // //     width: 290*2,
        // //     height: 120*2,
        // //     radius: 10,
        
        // //     color: 0xffffff,
        // //     alpha: 0.15,
        // // }).setOrigin(0.5);


        // // this.rect.setBlendMode(BlendModes.DIFFERENCE);


        // //layer.add(this.rect);

        // //const container = this.add.container();

        // //this.rect.postFX.addBlur(1, 2, 2,2, 0xffffff,4);
        // //container.setSize(290*2, 120*2)
        // //container.add(rect);
        // //const fx = container.postFX.addBlur(1, 1, 1,2, 0xffffff,4);

        // //rect.preFX.addBlur(2,2,2,2,"0x000748");
        // //rect.postFX.addBlur(1, 0, 0, 0, 0xffffff, 6);
        // //rect.preFX.addBlur();

        // var rect2 = this.add.rexRoundRectangle({
        //     x: this.scale.width /2,
        //     y: this.scale.height - this.scale.height / 5,
        //     width: 290*2,
        //     height: 120*2,
        //     radius: 10,
        
        //     color: 0x070012,
        //     alpha: 0,
        
        //     strokeColor: 0xffffff,
        //     strokeAlpha: 0.3,
        //     strokeWidth: 3
        // }).setOrigin(0.5);


        // // this.graphics = this.add.graphics();

        // // this.graphics.fillStyle(0xffffff, 0.6);

        // // //  32px radius on the corners
        // // this.graphics.fillRoundedRect(85 , this.scale.height - this.scale.height / 4,  this.scale.width / 1.29, this.scale.height / 1.29, 32);

        // // this.graphics.postFX.addGradient(0x9c9c9c, 0x7f0077);
        // // //this.graphics.postFX.addBlur(1, 2, 2, 1, 0xffffff, 6);

        // // this.graphics.lineStyle(1, 0xff00ff, 2);
        // // this.graphics.strokeRoundedRect(85 , this.scale.height - this.scale.height / 4, this.scale.width / 1.29, this.scale.height / 1.29, 32);



        // // console.log(this.graphics)

        // // const svg0 = this.add.image(85 , this.scale.height /2, 'timecounterbg').setOrigin(0);
        // // svg0.postFX.addBlur(2,1,1,2,'0xffffff', 3);
        // // const div = document.createElement('div');
        // // div.style = 'background-color: lime; width: 220px; height: 100px; font: 48px Arial; font-weight: bold';
        // // div.innerText = 'Phaser 3';

        // // this.element = this.add.dom(300,200, div).setOrigin(.5);
        // //this.DaysTime = this.add.text(rect2.getTopLeft, rect2.getTopLeft, ``,  { fontSize: 32, fontFamily: 'Oswald', color: '#eee', fontWeight:700 }).setOrigin(0).setFontStyle("bold")
        // console.log(rect2.width, rect2.height)

        // const size = (1 * 145) - (145 / 2)
       
        // // this.remaining_time_text = this.add.text(this.scale.width - 10, 10, `test`,  { fontSize: 32, fontFamily: 'Oswald', color: '#eee', fontWeight:700 }).setOrigin(0.5).setFontStyle("bold")
        // //     .setOrigin(1, 0);
        // //const remaningTime = this.timeLeft(this.remaining_time)
        // //this.remaining_time_text.setText(`${remaningTime.days} <br/> days, ${remaningTime.hours} hours, ${remaningTime.minutes} minutes, ${remaningTime.seconds} seconds`);

        // // this.grabImage = this.add.image(0,0);
        // // const textureManager = this.textures;

        
        // // this.scene.get('MainScene').game.renderer.snapshotArea(0, 0, 256, 256, (image) =>
        // // { 
            

        // //     if (textureManager.exists('area'))
        // //     {
        // //         textureManager.remove('area');
        // //     }

        // //     //textureManager.addImage('area', image);
        // //     this.grabImage.setTexture(image);
        // //     //particles.setTexture('area')
        // // });

        // // this.snap = this.scene.get('MainScene').game.renderer.snapshotArea(0, 0, 256, 256);
        // // this.grabImage.setTexture(this.snap);


        // // this.input.on('pointerdown', (pointer) => {
        // const renderTexture = this.add.renderTexture(0, 0, this.scale.width, this.scale.height);
        

        // // Define the area you want to capture
        // const captureX2 = this.scale.width /2; // X position of the area in SceneA
        // const captureY2 = this.scale.height /2; // Y position of the area in SceneA
        // const captureWidth = 300; // Width of the area
        // const captureHeight = 200; // Height of the area

        // // Draw the specific area of SceneA onto the RenderTexture
        // const sceneA = this.scene.get('MainScene'); // Get SceneA
        // renderTexture.setCrop(200, 200, captureWidth, captureHeight);
      
      
        // //   // Add the tree image to use it as a mask
        // //    const treeMask = this.add.image(300, 200, 'logo');
        // //    treeMask.setScale(0.5).setTint(0x000000);

        // //    //treeMask.setDisplaySize(300,200);

        // //    //   // Create a bitmap mask from the tree image
        // //      const mask = treeMask.createBitmapMask();
     
        //    //   // Apply the mask to the rectangle image
        //      //renderTexture.setMask(mask);
        //      //renderTexture.mask.invertAlpha = true;
     
        //    //   Optional: Hide the tree image (mask is applied, we don't need to display it)
        //     // treeMask.setVisible(false);


        //     // renderTexture.draw(sceneA.children, 0, 0);

        //     // renderTexture.mask = new Phaser.Display.Masks.BitmapMask(this, treeMask);
     

        // //   renderTexture.saveTexture('mytexture');
        // //   renderTexture.setActive(true);
        //   //renderTexture.setPosition(this.scale.width/2, this.scale.height)
  


        // //renderTexture.postFX.addBlur(2, 1, 1,3, 0xffffff,4);
        

        // // // Create a sprite from the captured render texture and position it
        // // const sprite = this.add.sprite(400, 300, renderTexture)
        // // sprite.setAngle(45)
        // // //sprite.setDisplaySize(captureWidth, captureHeight*2); // Set the display size to match the capture 
        // // })

        this.graphics2 = this.add.graphics();
        this.graphics3 = this.add.graphics();

        this.graphics2.fillStyle(0xffff00, 1);

        //  32px radius on the corners 
        this.graphics2.fillRoundedRect(this.scale.width/2-290,this.scale.height - this.scale.height / 5-120, 290*2, 120*2, 10);


        // TODO
        //this.graphics2.fillRoundedRect(this.scale.width/2-290*1.7/2,this.scale.height - this.scale.height / 5-120, 290*1.7, 120*1.7, 10);

        this.graphics3.lineStyle(4, 0xffffff, 0.5);

 




        this.graphics2.setVisible(false);


        //const bunny1 = this.add.sprite(400, 300, 'timecounterbg').setTint(0x000000);

        const checker = this.add.sprite(this.scale.width/2, this.scale.height/2, 'testydraw');
        //const checker2 = this.add.sprite(400,300, 'testydraw');
        //const checker = this.add.sprite(400, 300, 'lotto-bg');

        checker.mask = new Phaser.Display.Masks.BitmapMask(this, this.graphics2);
        checker.setScale(1).setAlpha(1).setDisplayOrigin(this.scale.width/2,this.scale.height/2);
        //checker.setTint('0x9c9c9c', '0x070012','0x070012','0x7f00ff');
        //checker.setTint('0xFFFFFF', '0xFFFFFF','0xFFFFFF','0xFFFFFF');

        checker.preFX.addBlur(2,1,1,3);
        //checker.preFX.addBlur();
        var gradient = checker.preFX.addGradient(0x7F00FF, 0x070012, 0.9, 0.2, 0.5, 0.2, 0.5, 0);
        //checker.setTint(0x999999)


        // Log the current scale and the width/height comparison
        this.logScaleInfo(checker);

        // Create a render texture with the same size as the game

        if (!this.textures.exists('blurredTimer')) {
            const renderTexture = this.add.renderTexture(0, 0, this.scale.width, this.scale.height);

            // Draw the background image with PreFX onto the render texture
            renderTexture.draw(checker, this.scale.width/2, this.scale.height/2);//bg.x - bg.width / 2, bg.y
    
            // Save the render texture as a new Phaser texture
            renderTexture.saveTexture('blurredTimer', renderTexture.texture);    
            renderTexture.setVisible(false)
        }

        
        checker.clearFX();

        // Remove the original background image
        checker.destroy();

        // Add the new texture to the game as a sprite or image
        const newBackground = this.add.image(this.scale.width/2, this.scale.height/2, 'blurredTimer');


        //checker.setAlpha(0.7);
        //checker.setTint('0xCCCCCC');
        // //checker.postFX.addBlur(2, 1, 1,2, 0xffffff,4);
        
        //checker.postFX.addBlur(2,1,1,2,0xFFFFFF);
        
        //checker.preFX.addBlur();

        //checker.postFX.addGlow(0xf00FFF0, 1, 0, true, 1, 64);

        //493
        const boxReletiveSize = 493;
        const boxReletiveSizeD4 = 133.25;

        const topleftX = this.scale.width /2-boxReletiveSize/2;
        const topleftY = this.scale.height - this.scale.height / 5-135;
        this.graphics3.strokeRoundedRect(this.scale.width/2-290,this.scale.height - this.scale.height / 5-120, 290*2, 120*2, 10);
        
        
        // TODO
        //this.graphics3.strokeRoundedRect(this.scale.width/2-290*1.7/2,this.scale.height - this.scale.height / 5-120, 290*1.7, 120*1.7, 10);

        if(!this.remaining_time){



        this.NextDraw = this.add.text(topleftX+boxReletiveSize/2 , topleftY + 72, `MISSED THE LAST DRAW?`,  { fontSize: 36, fontFamily: 'Oswald', color: '#fff', fontWeight:500 }).setOrigin(0.5)
        this.NextDraw.setFontStyle("500")
        
        //const fx1 = this.NextDraw.postFX.addGlow(0x00FFF0, 1, 0, false, 0.1, 50);
            

        this.NextDrawInfo = this.add.text(topleftX+boxReletiveSize/2 , topleftY + 160, `Don’t worry! We're preparing the next round of big winnings! Please check back soon for details on our upcoming draw, where you could be the lucky winner.`,  
            { 
                fontSize: 22, 
                fontFamily: 'Oswald', 
                color: '#fff', 
                fontWeight:400, 
                align: 'center',
                wordWrap: { width:  boxReletiveSize, useAdvancedWrap: true }
            }).setOrigin(0.5)
        this.NextDrawInfo.setFontStyle("400")

            return
        }
        const remaningTime = this.timeLeft(this.remaining_time)

        // const textNumStyle = { fontSize: 48, fontFamily: 'Oswald', color: '#fff', fontWeight:500 };
        // const textTimeStyle = { fontSize: 28, fontFamily: 'Oswald', color: '#fff', fontWeight:700 };
        //this.graphics3.postFX.addShine(0.9, .3, 3);
         
        this.DaysText = this.add.bitmapText(topleftX + (1 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) - 20, topleftY + 100*2, 'Oswald-Medium', `Days` , 30).setOrigin(0.5,1);
        this.DaysNum = this.add.bitmapText(topleftX + (1 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)- 20, topleftY + 105, 'oswald2', remaningTime.days , 48).setOrigin(0.5);

        //this.DaysText.postFX.addGlow(0x00FFF0, 2, 0, false, 0.1, 32);
        //this.DaysText = this.add.text(topleftX + (1 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) - 20, topleftY + 105*2, `Days`,  textTimeStyle).setOrigin(0.5)
        //this.DaysText.setFontStyle("bold");
        //this.DaysText.setShadow(0,0, '#00fff0', 6 ,true,true);

        //this.DaysNum = this.add.text(topleftX + (1 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)- 20, topleftY + 136, remaningTime.days,  textNumStyle).setOrigin(0.5)
        //this.DaysNum.setFontStyle("bold");

        //this.DaysNum.setShadow(0,0, '#00fff0', 6 ,true,true);

        this.HoursText = this.add.bitmapText(topleftX + (2 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) - 20, topleftY + 100*2, 'Oswald-Medium', `Hours` , 30).setOrigin(0.5,1);
        this.HoursNum = this.add.bitmapText(topleftX + (2 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) - 20, topleftY + 105, 'oswald2', remaningTime.hours , 48).setOrigin(0.5);
        //this.HoursText.postFX.addGlow(0x00FFF0, 2, 0, false, 0.1, 32);
        // this.HoursText = this.add.text(topleftX + (2 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) - 20, topleftY + 105*2, `Hours`, textTimeStyle).setOrigin(0.5)
        // this.HoursText.setFontStyle("bold")

        // this.HoursText.preFX.setPadding(32);

        // const fx = this.HoursText.preFX.addShadow(0, 0, 0.06, 0.75, 0x00fff0, 4, 0.8);
        //.preFX.addShadow(0, 0, 0.01, 1, 0xf00FFF0, 4, 4);;

        // this.HoursNum = this.add.text(topleftX + (2 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) - 20, topleftY+ 136, remaningTime.hours,  textNumStyle).setOrigin(0.5)
        // this.HoursNum.setFontStyle("bold");


        this.MinutesText = this.add.bitmapText(topleftX + (3 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)-20, topleftY + 100*2, 'Oswald-Medium', `Minutes` , 30).setOrigin(0.5,1);
        this.MinutesNum = this.add.bitmapText(topleftX + (3 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)-20, topleftY+ 105, 'oswald2', remaningTime.minutes , 48).setOrigin(0.5);
        //this.MinutesText = this.add.text(topleftX + (3 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)-20, topleftY + 105*2, `Minutes`,  textTimeStyle).setOrigin(0.5)
        //this.MinutesText.preFX.setPadding(32);
        //this.MinutesText.setFontStyle("bold")
        //.postFX.addGlow(0xf00FFF0, 1, 0, false, 1, 64);

        // this.MinutesNum = this.add.text(topleftX + (3 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)-20, topleftY+ 136, remaningTime.minutes,  textNumStyle).setOrigin(0.5)
        // this.MinutesNum.setFontStyle("bold");

        this.SecondsText = this.add.bitmapText(topleftX + (4 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)-20, topleftY + 100*2, 'Oswald-Medium', `Seconds` , 30).setOrigin(0.5,1);
        this.SecondsNum = this.add.bitmapText(topleftX + (4 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) -20, topleftY + 105, 'oswald2', remaningTime.seconds , 48).setOrigin(0.5);
        //this.SecondsText = this.add.text(topleftX + (4 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2)-20, topleftY + 105*2, `Seconds`,  textTimeStyle).setOrigin(0.5)
        //this.SecondsText.setFontStyle("bold")
        //.preFX.addGlow(0x00FFF0,1);
        //.postFX.addBloom("0x00FFF0",0,0,1,20);;

        // this.SecondsNum = this.add.text(topleftX + (4 * boxReletiveSizeD4) - (boxReletiveSizeD4 / 2) -20, topleftY + 136, remaningTime.seconds,  textNumStyle).setOrigin(0.5)
        // this.SecondsNum.setFontStyle("bold")





        this.NextDraw = this.add.text(topleftX+boxReletiveSize/2 -30 , topleftY + 62, `Next Draw: ${this.formatUnixTimestamp(this.remaining_time)}`,  { fontSize: 30, fontFamily: 'Oswald', color: '#fff', fontWeight:500 }).setOrigin(0.5)
        this.NextDraw.setFontStyle("500")

        this.NextDrawGMT = this.add.text(this.NextDraw.x + this.NextDraw.width/2 +6 , topleftY + 60 + this.NextDraw.height/2, `GMT+8`,  { fontSize: 20, fontFamily: 'Oswald', color: '#fff', fontWeight:500 }).setOrigin(0, 1)
        if(this.status != "open"){
            this.NextDraw.setText("Draw In Progress")
            this.NextDrawGMT.setVisible(false)
        }
        

        this.colon = []
        for (let index = 1; index < 4; index++) {
          
            this.colon[index] = this.add.text(topleftX + (index * boxReletiveSizeD4) - (boxReletiveSizeD4/6), topleftY + 150, `:`,   { fontSize: 48, fontFamily: 'Oswald', color: '#fff', fontWeight:500 }).setOrigin(0.5)
            //const element = array[index];
        }
    }

    formatUnixTimestamp(unixTimestamp) {
        // Create a new Date object from the Unix timestamp
        const date = new Date(unixTimestamp * 1000);
    
        // Array of month abbreviations
        const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    
        // Get the day, month, year, hours, and minutes
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
    
        // Format the date string
        return `${day} ${month} ${year} ${hours}:${minutes}`;
    }


    timeLeft(unixTimestamp) {
        // Get the current time and the future time based on the unix timestamp
        const now = new Date().getTime();
        const futureTime = unixTimestamp * 1000; // Convert to milliseconds
    
        // Calculate the time difference
        const timeDiff = futureTime - now;
    
        // Check if the future time is in the past
        if (timeDiff <= 0) {
            return {
                days:  padNumber(0),
                hours: padNumber(0),
                minutes: padNumber(0),
                seconds: padNumber(0)
            };
        }
    
        // Calculate the number of days, hours, minutes, and seconds
        const days = padNumber(Math.floor(timeDiff / (1000 * 60 * 60 * 24)));
        const hours = padNumber(Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        const minutes = padNumber(Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)));
        const seconds = padNumber(Math.floor((timeDiff % (1000 * 60)) / 1000));
    
        // Return the results as an object
        return {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    }
    
    
    update_points(points) {
        //this.points_text.setText(`POINTS:${points.toString().padStart(4, "0")}`);
    }

    update_timeout(timeout) {
        this.remaining_time_text.setText(`REMAINING:${timeout.toString().padStart(2, "0")}s`);
    }

    update(time, s) {
    
        if(!this.remaining_time){
            return
        }
	
        //this.captureSceneA() 

        const remaningTime = this.timeLeft(this.remaining_time)

        if (remaningTime.days == 0 && remaningTime.hours == 0 && remaningTime.minutes ==0 && remaningTime.seconds == 0 ){
            if (this.status == "open"){
                this.updateCounter()
                
                return;
            }

            if(this.status == "closed" && this.triggered == false){
            this.triggered = true
                // 5-second delay
            this.time.delayedCall(5000, () => {
                // Emit an event on the Scene Manager
                this.scene.get('MenuScene').events.emit('DrawEvent', { message: 'Draw Reset Timer' });
            });
             // Emit an event every 5 seconds
            // this.time.addEvent({
            //     delay: 5000,
            //     loop: true,
            //     callback: () => {
            //         this.events.emit('myEvent', { message: 'Hello from Scene B' });
            //     },
            // });

            }
            
        
        }
        
        

        if (+this.DaysNum.text !== +remaningTime.days){
            this.DaysNum.setText(remaningTime.days);
        }
        
        if (+this.HoursNum.text !== +remaningTime.hours){
            this.HoursNum.setText(remaningTime.hours);       
        }

        if (+this.MinutesNum.text !== +remaningTime.minutes){
            this.MinutesNum.setText(remaningTime.minutes);
        }

        if (+this.SecondsNum.text !== +remaningTime.seconds){
            this.SecondsNum.setText(remaningTime.seconds);    
        }
        
        
        

        //this.remaining_time_text.setText(`${remaningTime.days} days, ${remaningTime.hours} hours, ${remaningTime.minutes} minutes, ${remaningTime.seconds} seconds`);
    }

    updateCounter(){
        this.status = "closed"
        this.NextDraw.setText("Draw In Progress")
        this.NextDrawGMT.setVisible(false)
        this.remaining_time += 2*60
        this.scene.get('MenuScene').events.emit('CloseEvent', { message: 'Draw Reset Timer' });

    }

    captureSceneA() {
        this.rt.clear();
        //this.rt.setCrop(this.scale.width /2, this.scale.height - this.scale.height / 5, 290*2, 120*2);
        this.rt.draw([this.scene.get('MainScene').children, this.scene.get('MenuScene').children], 0 ,0);
        //this.rt.setCrop(this.scale.width /2, this.scale.height - this.scale.height / 5, 290*2, 120*2);
        //this.rt.setCrop(this.scale.width /2, this.scale.height - this.scale.height / 5, 290*2, 120*2);
    }


    logScaleInfo(gameObject) {
        // Current scale
        const currentScaleX = gameObject.scaleX;
        const currentScaleY = gameObject.scaleY;

        // Original width and height
        const originalWidth = gameObject.width;   // Unscaled dimensions
        const originalHeight = gameObject.height;

        // Current (scaled) width and height
        const currentWidth = gameObject.displayWidth;  // Scaled dimensions
        const currentHeight = gameObject.displayHeight;

        // console.log("Current Scale:", currentScaleX, currentScaleY);
        // console.log("Original Width/Height:", originalWidth, originalHeight);
        // console.log("Current Width/Height:", currentWidth, currentHeight);
    }
}